import React from "react";
import { Navigate } from "react-router";
import { NavLink} from "react-router-dom";
import Base from "../Base";

export default class LetterEvents extends Base {
    constructor(props) {
        super(props);

        this.state = {
            caller: props.Caller,
            controllerName: "letterevent",
            data: null,
            loading: true,
            configName: "letterevent_grid",
            moduleName: "",
            filters: {
                letterId: props.LetterId
            },
        };
    }
    componentDidMount() {

        this.refreshData();
    }

    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "userName", caption: "کاربر", show: true },
                { field: "typeString", caption: "نام رخداد", show: true },
                { field: "dateString", caption: "تاریخ ثبت", show: true },
            ],
        };
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach((f) => {
            if (f.field == "userName" && f.show)
                t.push({ field: f.field, headerName: f.caption });
            if (f.field == "typeString" && f.show)
                t.push({
                    field: f.field,
                    headerName: f.caption
                });
            if (f.field == "dateString" && f.show)
                t.push({ field: f.field, headerName: f.caption });
        });

        return t;
    }

    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div
                className="modal-backdrop fade in"
                style={{ height: "100%" }}
                onClick={(e) => this.closeMe()}
            ></div>
            <div className="modal-dialog ui-draggable" style={{ minWidth: "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ padding: "0" }}>
                        <div className="modal-header modal-header-info">
                            <button
                                type="button"
                                className="close"
                                onClick={(e) => this.closeMe()}
                                aria-label="Close"
                            >
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title">

                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">

                                {this.getToolBar(false, {
                                    add: false,
                                    print: false,
                                    pdf: false,
                                    excell: false,
                                    remove: false,
                                    config: false,
                                    otherFilters: "",
                                })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns(),
                                    rowSelection: 'singleRow'
                                })}

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-default btn-smoke"
                                onClick={(e) => this.closeMe()}
                            >
                                انصراف
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                ,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">{this.renderForm()}</div>
                    </div>
                </div>,
            ];

        return contents;
    }
}